import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { authContext } from "../Context/Authentication/authContext";
import { TravelExplore } from "@mui/icons-material";
import "./Header.scss";
import {
  Home as HomeIcon,
  Public as SocialIcon,
  Fitbit as FitbitIcon,
  PersonAdd as PersonAddIcon,
} from "@mui/icons-material";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import LogoutIcon from "@mui/icons-material/ExitToApp";
import Logo from "../assets/slate-logo.svg";
import { hover } from "@testing-library/user-event/dist/hover";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import MapPopUp from "../ArcGISMap/MapPopUp";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  OutlinedInput,
  Select,
  styled,
} from "@mui/material";
import { DialogTitleProps } from "../SideMenu/SideMenu";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { Bars } from "react-loader-spinner";
import axios from "axios";
import { otherBaseURL } from "../config";
import GroupsIcon from "@mui/icons-material/Groups";

const pages = ["City Wise Data", "Zipcode Wise Data"];

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    borderBottom: "1px solid #f7b047",
    borderTop: "1px solid #f7b047",
  },

  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  "& .MuiDialogTitle-root": {
    color: "#f7b047",
    padding: "10px",
  },
  "& .MuiSvgIcon-root": {
    color: "#f7b047",
  },
  "& .MuiButton-root": {
    color: "#f7b047",
  },
  "& .MuiDialog-paper": {
    maxWidth: "44%",
    background:
      "linear-gradient(0deg, #13223D, #234f70 100%) no-repeat !important",
  },
}));

export const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const Header = (props: any) => {
  const navigate = useNavigate();
  const { dispatch, state }: any = React.useContext(authContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const urlLocation: any = useLocation();
  const [censusMap, setCensusMap]: any = React.useState(false);
  const [isOpen, setOpen] = React.useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phone, setPhone] = useState("");
  const [userloading, setUserLoading] = React.useState(false);
  const [showError, setShowError] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [errorMsg, setErrorMessage] = useState("");
  const [isLoading, setLoading] = useState(true);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    dispatch({
      type: "SET_DRAWER_OPEN",
      payload: !state.drawerOpen,
    });
  };

  const showCensusPup = () => {
    setCensusMap(true);
  };

  const displayCensusMap = (val: boolean) => {
    setCensusMap(val);
  };

  const handleInputChange = (ev: any) => {
    console.log(ev);

    if (ev.target.name === "email") {
      setShowError(false);
      setEmail(ev.target.value);
    } else if (ev.target.name === "firstName") {
      setShowError(false);
      setFirstName(ev.target.value);
    } else if (ev.target.name === "companyName") {
      setShowError(false);
      setCompanyName(ev.target.value);
    } else if (ev.target.name === "phone") {
      setShowError(false);
      setPhone(ev.target.value);
    } else if (ev.target.name === "lastName") {
      setShowError(false);
      setLastName(ev.target.value);
    } else if (ev.target.name === "role") {
      setShowError(false);
      setRole(ev.target.value);
    }
  };
  const addUser = async () => {
    setShowError(false);
    setShowConfirmation(false);
    if (email === "" || firstName === "" || lastName === "") {
      setShowError(true);
      setErrorMessage("😕 Please fill out the empty fields");
      return;
    }
    const payload: any = {
      email: email.toLowerCase(),
      firstname: firstName,
      lastname: lastName,
      role: role,
      contact: phone,
      company: companyName,
    };
    const response = await axios
      .post(`${otherBaseURL}register`, payload)
      .then((responce) => {
        console.log(responce);
        setShowConfirmation(true);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setShowError(true);
        setErrorMessage("😕 Username/Email already exists");
        setLoading(false);
      });
  };

  const logout = () => {
    setAnchorEl(null);
    localStorage.clear();
    dispatch({
      type: "LOGOUT",
    });
  };
  const AddUser = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setEmail("");
    setRole("");
    setFirstName("");
    setLastName("");
    setShowConfirmation(false);
    setShowError(false);
  };

  const getForms = () => {
    return (
      <form
        className="ftLogin_container_form"
        onSubmit={(ev) => {
          ev.preventDefault();
          addUser();
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Email*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="email"
              value={email}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <div style={{ position: "relative", left: "-20px" }}>
            <Typography
              className="form_label"
              gutterBottom
              style={{ marginLeft: "14px" }}
            >
              Role*
            </Typography>
            <Select
              value={role}
              label="Select value as"
              onChange={handleInputChange}
              name="role"
              className="role_dropdown"
              autoComplete="off"
            >
              <MenuItem value={"user"}>User</MenuItem>
              <MenuItem value={"admin"}>Admin</MenuItem>
            </Select>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              First Name*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="firstName"
              value={firstName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Last Name*
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="lastName"
              value={lastName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Company Name(optional)
            </Typography>
            <OutlinedInput
              className="form_input_name"
              name="companyName"
              value={companyName}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
          <FormControl sx={{ m: 2, width: "95%" }}>
            <Typography className="form_label" gutterBottom>
              Phone(optional)
            </Typography>
            <OutlinedInput
              type="number"
              className="form_input_name"
              name="phone"
              value={phone}
              onChange={handleInputChange}
              autoComplete="off"
            />
          </FormControl>
        </div>

        <FormControl
          sx={{ m: 2 }}
          style={{ margin: "12px", display: "flex", alignItems: "center" }}
        >
          <Button
            variant="outlined"
            // onClick={() => login()}
            type="submit"
            className="loginButton"
          >
            Add Account
            <Bars
              height="30"
              color="#035F77"
              ariaLabel="bars-loading"
              wrapperStyle={{ float: "left" }}
              wrapperClass=""
              visible={userloading}
            />
          </Button>
        </FormControl>

        {showConfirmation && (
          <div className="errorContainer">
            <FormControl sx={{ m: 1 }}>
              <FormHelperText id="accountId-error">
                Invitation sent Successfully
              </FormHelperText>
            </FormControl>
          </div>
        )}

        {showError && (
          <div className="errorContainer">
            <FormControl sx={{ m: 1 }}>
              <FormHelperText error id="accountId-error">
                {errorMsg}
              </FormHelperText>
            </FormControl>
          </div>
        )}
      </form>
    );
  };

  return urlLocation.pathname !== "/" ? (
    <Box sx={{ flexGrow: 1 }} className="header-main">
      <AppBar position="fixed">
        <Toolbar className={"header-main__toolbar"}>
          <img
            id="Header-Logo"
            src={Logo}
            className="header-logo"
            onClick={() => navigate("/")}
          />
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={handleDrawerToggle}
            className={
              state.drawerOpen
                ? "header-main__toolbar__iconButton header-main__toolbar__iconButton__open"
                : "header-main__toolbar__iconButton"
            }
          >
            {!state.drawerOpen ? <MenuIcon /> : <MenuIcon />}
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              flexGrow: 1,
              display: { xs: "none", sm: "block" },
              color: "#fff",
            }}
          >
            Estate Intel 1.0
          </Typography>
          <div className="header-main__toolbar__rightContainer">
            <HomeIcon className="right-icons" onClick={() => navigate("/")} />{" "}
            &nbsp; &nbsp;
            <span className="header-main__toolbar__rightContainer__text">
              Welcome {state?.user?.username}!
            </span>
            <IconButton
              size="large"
              color="inherit"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              sx={{ ml: 1 }}
              className="right-icons"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              keepMounted
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              className="header-menu"
            >
              <div>
                {/* First row of menu items */}
                <div className="header-main__menuContainer">
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/");
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <img
                          src={icon2}
                          className="header-main__menuContainer__menuItem__iconContainer__icon"
                        />
                        <span>Home</span>
                      </div>
                    </MenuItem>
                  </div>

                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/home");
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <FitbitIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Analyze</span>
                      </div>
                    </MenuItem>
                  </div>
                </div>

                {/* Second row of menu items */}
                <div className="header-main__menuContainer">
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/social");
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <SocialIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Social</span>
                      </div>
                    </MenuItem>
                  </div>

                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        navigate("/report");
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <img
                          src={icon3}
                          className="header-main__menuContainer__menuItem__iconContainer__icon"
                        />
                        <span>Report</span>
                      </div>
                    </MenuItem>
                  </div>
                </div>

                {/* Third row of menu items, conditionally rendered for admin */}
                <div className="header-main__menuContainer"              style={state.user.role==='admin'?{position:'relative',left:'12px',marginBottom: "0rem"}:{marginBottom: "0rem"}}>
                  <div className="header-main__menuContainer__menuItem">
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        showCensusPup();
                      }}
                      className="mat-menu-item-sm header-menu-item"
                    >
                      <div className="header-main__menuContainer__menuItem__iconContainer">
                        <TravelExploreIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                        <span>Visualize</span>
                      </div>
                    </MenuItem>
                  </div>
              {
                (state.user.role==='user' || state.user.role==='trial') && (
                  <div className="header-main__menuContainer__menuItem">
                  <MenuItem
                    onClick={logout}
                    className="mat-menu-item-sm header-menu-item"
                  >
                    <div className="header-main__menuContainer__menuItem__iconContainer">
                      <LogoutIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                      <span>Logout</span>
                    </div>
                  </MenuItem>
                </div>
                )
              }
                {state.user.role === "admin" && (
                    <div className="header-main__menuContainer__menuItem">
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          navigate("/users");
                        }}
                        className="mat-menu-item-sm header-menu-item"
                      >
                        <div className="header-main__menuContainer__menuItem__iconContainer">
                          <GroupsIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                          <span>User Management</span>
                        </div>
                      </MenuItem>
                    </div>
                  )}

                  {/* {state.user.role != "admin" && (
                    <div className="header-main__menuContainer__menuItem">
                      <MenuItem
                        onClick={logout}
                        className="mat-menu-item-sm header-menu-item"
                      >
                        <div className="header-main__menuContainer__menuItem__iconContainer">
                          <LogoutIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                          <span>Logout</span>
                        </div>
                      </MenuItem>
                    </div>
                  )} */}
                </div>
                <div className="header-main__menuContainer">
                  {state.user.role === "admin" && (
                    <div className="header-main__menuContainer__menuItem">
                      <MenuItem
                        onClick={logout}
                        className="mat-menu-item-sm header-menu-item"
                      >
                        <div className="header-main__menuContainer__menuItem__iconContainer">
                          <LogoutIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                          <span>Logout</span>
                        </div>
                      </MenuItem>
                    </div>
                  )}
                </div>

                {/* Last row: Conditional Logout */}
                {/* <div className="header-main__menuContainer">
      {state.user.role === "user" && (
        <div className="header-main__menuContainer__menuItem">
          <MenuItem
            onClick={logout}
            className="mat-menu-item-sm header-menu-item"
          >
            <div className="header-main__menuContainer__menuItem__iconContainer">
              <LogoutIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
              <span>Logout</span>
            </div>
          </MenuItem>
        </div>
      )}

      {state.user.role === "admin" && (
        <>
          <div className="header-main__menuContainer__menuItem">
            <MenuItem
              onClick={logout}
              className="mat-menu-item-sm header-menu-item"
            >
              <div className="header-main__menuContainer__menuItem__iconContainer">
                <LogoutIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                <span>Logout</span>
              </div>
            </MenuItem>
          </div>

          <div className="header-main__menuContainer__menuItem">
            <MenuItem
              onClick={logout}
              className="mat-menu-item-sm header-menu-item"
            >
              <div className="header-main__menuContainer__menuItem__iconContainer">
                <GroupsIcon className="header-main__menuContainer__menuItem__iconContainer__icon1" />
                <span>Teammates</span>
              </div>
            </MenuItem>
          </div>
        </>
      )}
    </div> */}
              </div>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      {censusMap && <MapPopUp displayCensusMap={displayCensusMap} />}
      <BootstrapDialog
        onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleCloseDialog}
        >
          <div style={{ textAlign: "center" }}>
            <img
              id="Header-Logo"
              alt="header-logo"
              src={Logo}
              className="header-logo"
              height="80px"
              width="70px"
              onClick={() => navigate("/")}
            />
            <p style={{ padding: 0, margin: 0, marginTop: "-8px" }}>
              {" "}
              Add Account
            </p>
          </div>
        </BootstrapDialogTitle>
        <DialogContent dividers>{getForms()}</DialogContent>
      </BootstrapDialog>
    </Box>
  ) : (
    <></>
  );
};

export default Header;